import { render, staticRenderFns } from "./NewsInfo.vue?vue&type=template&id=323a58fa&scoped=true&lang=pug"
import script from "./NewsInfo.vue?vue&type=script&lang=js"
export * from "./NewsInfo.vue?vue&type=script&lang=js"
import style0 from "./NewsInfo.vue?vue&type=style&index=0&id=323a58fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a58fa",
  null
  
)

export default component.exports